import styled, { css } from 'styled-components';
import { colors } from '@ardoq/design-tokens';
import { URL_BOX_ICON_CLASS_NAME } from 'yfilesExtensions/styles/consts';

export const FillingDiv = styled.div`
  flex: 1;
  height: 100%;
`;
export const FILTER_DIMENSION_WORKAROUND_CSS_CLASS =
  'filter-dimension-workaround';
export const GraphContainer = styled(FillingDiv)<{ $isModern?: boolean }>`
  svg {
    g.component {
      stroke: #333;
      stroke-width: 0.5px;
      stroke-opacity: 1;
      &:not(.${URL_BOX_ICON_CLASS_NAME}) {
        pointer-events: bounding-box;
      }
    }

    g > path.workspace {
      fill: ${colors.grey200};
      fill-opacity: 1;
    }
    .tagGraphNode,
    .fieldGraphNode {
      fill: #ececec;
      stroke: black;
    }
    .allGraphNode {
      fill: #f6f7fa;
      stroke: black;
    }
    .genericGroup {
      stroke: black;
    }
    .fade-out,
    .fade-out > path {
      opacity: 0.25;
    }
  }

  .yfiles-url-box {
    cursor: pointer;
    &:hover {
      fill: rgb(210, 210, 210);
    }
  }

  .image-diff-background {
    fill: hsl(0, 0%, 90%);
    opacity: 1;
  }

  path.visual-diff-placeholder:not(.integration):not(.parent-child-reference),
  rect.visual-diff-placeholder,
  image.visual-diff-placeholder,
  use.visual-diff-placeholder,
  circle.visual-diff-placeholder:not(.image-diff-background) {
    opacity: 0;
  }

  .visual-diff-placeholder-label text,
  .visual-diff-placeholder-label text.integration {
    fill: ${colors.grey400};
    stroke: ${colors.grey400};
  }

  .label-visual-diff-mode text {
    fill: #3e4753 !important;
    stroke: #3e4753 !important;
  }

  .visual-diff-placeholder path.integration {
    fill: none;
    stroke: black;
    stroke-width: 2;
    stroke-dasharray: 2 4 !important;
  }

  .${FILTER_DIMENSION_WORKAROUND_CSS_CLASS} {
    opacity: 0;
    fill: none;
    pointer-events: none;
  }

  .visual-diff-placeholder.image-diff-background {
    fill: none;
    stroke: black;
    stroke-width: 2;
    stroke-dasharray: 2 4;
    opacity: 1;
  }

  .visual-diff-added,
  .visual-diff-removed,
  .visual-diff-changed {
    path {
      &.integration:not(.hoverPath) {
        stroke-width: 4px !important;
      }
    }
  }

  .component .visual-diff-added,
  .component .visual-diff-removed,
  .component .visual-diff-changed,
  .component .visual-diff-unchanged {
    fill: hsl(0, 0%, 50%) !important;
    color: hsl(0, 0%, 50%) !important;
    transition:
      fill 0.2s ease-out,
      color 0.2s ease-out;
  }

  .component:hover .visual-diff-changed {
    fill: hsl(0, 0%, 15%) !important;
    color: hsl(0, 0%, 15%) !important;
  }

  ${({ $isModern }) =>
    !$isModern &&
    css`
      path {
        &.integration:not(.hoverPath) {
          stroke-width: 2px;
          pointer-events: none;
        }
      }
    `}
`;
